import logo from '@assets/logos/mrwolf-black-simple-160.svg';
import { CheckIcon24 } from '@components/ui/WolfIcons';
import { useTranslation } from '@hooks/useTranslation';
import { Box, Typography } from '@mui/material';
import WolfButton from '../ui/WolfButton';

interface PaywallModalProps {
  handleUpgrade: () => void;
}

const PaywallModal: React.FC<PaywallModalProps> = ({ handleUpgrade }) => {
  const localePaywall = useTranslation('paywall');
  return (
    <Box className="flex justify-center items-center mt-4 flex-col">
      <Box className="flex items-center gap-4 mb-10" sx={{ width: '100%' }}>
        <Box>
          <img src={logo} alt="logo" width={56} />
        </Box>
        <Box>
          <Typography variant="h3" color="text.secondary" sx={{ fontWeight: 600 }}>
            {localePaywall['currentlyFreeTierPlan']}
          </Typography>
          <Typography variant="body16semibold" color="error.main" sx={{ fontWeight: 600 }}>
            {localePaywall['paywallErrorDescription']}
          </Typography>
        </Box>
      </Box>

      <Box className="flex flex-col items-center gap-2 mb-8">
        <Typography variant="h3semibold" className="text-center" sx={{ fontSize: 28, fontWeight: 700 }}>
          {localePaywall['upgradeTitle']}
        </Typography>
        <Typography className="text-center" variant="body16" color="text.secondary" sx={{ fontSize: 18 }}>
          {localePaywall['upgradeSubtitle']}
        </Typography>
      </Box>

      <Box className="flex flex-col md:flex-row gap-8 w-full items-start justify-between mb-8">
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ marginBottom: '20px', fontWeight: 700 }}>{localePaywall['includes']}</Typography>
          <Box className="flex items-center gap-2 mb-1">
            <CheckIcon24 />
            <Typography variant="body16" sx={{ fontWeight: 600 }}>
              {localePaywall['allFreeTierFeatures']}
            </Typography>
          </Box>
          <Box className="flex items-center gap-2 mb-1">
            <CheckIcon24 />
            <Typography variant="body16">{localePaywall['additionalUsers']}</Typography>
          </Box>
          <Box className="flex items-center gap-2 mb-1">
            <CheckIcon24 />
            <Typography variant="body16">{localePaywall['switchAnytime']}</Typography>
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            background: '#F6F8FA',
            borderRadius: 2,
            p: 3,
            minWidth: 200,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            width: { xs: '100%', md: 'auto' },
          }}>
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
            <Typography variant="h3semibold" sx={{ fontSize: 32, fontWeight: 700 }}>
              $15
            </Typography>
            <Typography variant="body16" color="text.secondary">
              {localePaywall['adminUserPriceDescription']}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
            <Typography variant="h3semibold" sx={{ fontSize: 32, fontWeight: 700 }}>
              $2
            </Typography>
            <Typography variant="body16" color="text.secondary">
              {localePaywall['readOnlyUserPriceDescription']}
            </Typography>
          </Box>
          <WolfButton
            variant="contained"
            color="primary"
            sx={{ mt: 2, width: '100%', borderRadius: 2, fontWeight: 700, fontSize: 18 }}
            onClick={handleUpgrade}>
            {localePaywall['cta']}
          </WolfButton>
        </Box>
      </Box>
    </Box>
  );
};

export default PaywallModal;
